import links from "@/links/links";

export default {
  actions: {
    FETCH(agencyId) {
      return this.get(links.CONFIGURATION_GET_BY_AGENCY(agencyId), {
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.CONFIGURATION_GET(id));
    },
    POST(item) {
      return this.post(links.CONFIGURATION_POST(), item);
    },
    PUT(item) {
      return this.put(links.CONFIGURATION_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.CONFIGURATION_DELETE(item.id), {
        delete: item.id,
      });
    },
  },
};
